import { render, staticRenderFns } from "./JournalTab.vue?vue&type=template&id=1f4a7ccb&"
import script from "./JournalTab.vue?vue&type=script&lang=js&"
export * from "./JournalTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports